import React from 'react'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import i18n from '~/i18n'

export default class PremiumSupportDrawer extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div>
                <h4 className='mar-b25'>{i18n.t('support:premiumSupport.title')}</h4>

                <div className='mar-b25'>{i18n.t('support:premiumSupport.intro')}</div>

                <div className='quicklinks'>
                    <div className={'mar-b20 quickFlex center-xs width-100'}>
                        <span className={'icon-mic text-lg text-primary'}></span>
                        <p className='pad-left-1 no-marg'>
                            <strong>{i18n.t('support:premiumSupport.skypeTitle')}</strong>{' '}
                            {i18n.t('support:premiumSupport.skypeDesc')}
                        </p>
                        <div className='mar-l-auto'>
                            <Button
                                className='primary button-sml'
                                text={i18n.t('support:premiumSupport.skypeButton')}
                                onClick={() => {
                                    window.open('skype://transpond', '_self')
                                }}
                            />
                        </div>
                    </div>
                    <div className='divider2 light no-marg mar-b20 '></div>
                    <div className={'mar-b20 quickFlex center-xs width-100'}>
                        <span className={'icon-envelope text-lg text-primary'}></span>
                        <p className='pad-left-1 no-marg'>
                            <strong>{i18n.t('support:premiumSupport.emailTitle')}</strong>
                        </p>
                        <div className='mar-l-auto'>
                            <Button
                                className='primary button-sml'
                                text={i18n.t('support:premiumSupport.emailButton')}
                                onClick={() => {
                                    window.open('mailto:mike@mpzmail.com', '_self')
                                }}
                            />
                        </div>
                    </div>
                    <div className='divider2 light no-marg mar-b20 '></div>
                    <div className={'mar-b20 quickFlex center-xs width-100'}>
                        <span className={'icon-lifebuoy text-lg text-primary'}></span>
                        <p className='pad-left-1 no-marg'>
                            <strong>{i18n.t('support:premiumSupport.ticketTitle')}</strong>
                        </p>
                        <div className='mar-l-auto'>
                            <Button
                                className='primary button-sml'
                                text={i18n.t('support:premiumSupport.ticketButton')}
                                onClick={() => {
                                    window.open('https://transpond.io/contactus', '_blank')
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
